import { HStack, type StackProps } from '@chakra-ui/react'
import type { ReactNode } from 'react'

type Props = {
  start?: ReactNode
  end?: ReactNode
} & StackProps

export function PageHeader({ start, end, ...rest }: Props) {
  return (
    <HStack justify="space-between" align="center" {...rest}>
      <HStack gap={3}>{start}</HStack>
      <HStack gap={3}>{end}</HStack>
    </HStack>
  )
}
